module.exports = __webpack_public_path__ + "media/images/about-us/Bottom Left - Mountains-58c236c2b055a18091357e91dd895d6d.png";